export default {
  user: {},
  device: {},
  userRelationships: {},
  userLicence: {},
  gradeMap: {},
  supportCountries: [
    'KR',
    'TW',
  ],
};



// WEBPACK FOOTER //
// ./src/app/auth/store/state.js